import { http } from '../util/http'
import { API_EP_API_DOMAIN } from '../config'
import headers from './employeeSystemHeader'
import axios from 'axios'

// 俱乐部小票机列表
export const fetchPrinterList = (params) => {
  return http({
    headers: headers(),
    url: `${API_EP_API_DOMAIN}/device/printer/club`,
    params,
  })
}

// 联盟小票机详情
export const fetchUnionPrinterDetail = (params) => {
  return http({
    headers: headers(),
    url: `${API_EP_API_DOMAIN}/device/printer/setting/detail`,
    params,
  })
}

// 普通小票类型列表
export const fetchReceiptTypes = (params) => {
  return http({
    headers: headers(),
    url: `${API_EP_API_DOMAIN}/device/printer/receiptType`,
    params,
  })
}

// 修改小票机设置
export const postPrinterData = (data) => {
  return http({
    headers: headers(),
    url: `${API_EP_API_DOMAIN}/device/printer/setting`,
    method: 'post',
    data,
  })
}

// 打印测试
export const postPrinterTest = (data) => {
  return http({
    headers: headers(),
    url: `${API_EP_API_DOMAIN}/device/printer/test`,
    method: 'post',
    data,
  })
}

// 删除小票机
export const removePrinter = (data) => {
  return http({
    headers: headers(),
    url: `${API_EP_API_DOMAIN}/device/printer/club/unbind`,
    method: 'post',
    data,
  })
}

// 新增小票打印机
export const addPrinter = (data) => {
  return http({
    headers: headers(),
    url: `${API_EP_API_DOMAIN}/device/printer/club/bind`,
    method: 'post',
    data,
  })
}

// 商品分类绑定小票机
export const bindingPrinter = (data) => {
  return http({
    headers: headers(),
    url: `${API_EP_API_DOMAIN}/device/printer/setting`,
    method: 'post',
    data,
  })
}

// 联盟小票打印机分页搜索列表
export const fetchUnionPrinterList = (params) => {
  return http({
    headers: headers(),
    url: `${API_EP_API_DOMAIN}/device/printer`,
    params,
  })
}

// 联盟新建小票打印机
export const addUnionPrinter = (data) => {
  return http({
    headers: headers(),
    url: `${API_EP_API_DOMAIN}/device/printer/union/bind`,
    method: 'post',
    data,
  })
}

// 小票机品牌列表
export const fetchBlandList = (params) => {
  return http({
    headers: headers(),
    url: `${API_EP_API_DOMAIN}/device/printer/printerType`,
    params,
  })
}

// 小票机列表详情（联盟）
export const fetchListPrinterDetail = (params) => {
  return http({
    headers: headers(),
    url: `${API_EP_API_DOMAIN}/device/printer/detail`,
    params,
  })
}

// 生成系统二维码（系统码）
export const fetchSystemQrCode = (params) => {
  return axios({
    responseType: 'blob',
    url: `${API_EP_API_DOMAIN}/device/printer/qr/generate`,
    params,
  })
}

// 分类关联小票机列表
export const fetchCategoryBinding = (params) => {
  return http({
    headers: headers(),
    url: `${API_EP_API_DOMAIN}/device/printer/setting/detail`,
    params,
  })
}

// 获取小票机状态
export const fetchPrinterStatus = (params) => {
  return http({
    headers: headers(),
    url: `${API_EP_API_DOMAIN}/device/printer/statuses`,
    params,
  })
}



// WEBPACK FOOTER //
// ./src/api/printer.js